import {
  ClipboardList,
  ExternalLink,
  File,
  GitBranch,
  GitCommitHorizontal,
  GitPullRequest,
  type LucideIcon,
  MessageSquareText,
  Rocket,
  Ticket,
} from "lucide-react";
import type { Artifact } from "../types";

const ICONS: Record<Artifact["type"], LucideIcon> = {
  pull_request: GitPullRequest,
  branch: GitBranch,
  commit: GitCommitHorizontal,
  summary: MessageSquareText,
  file: File,
  release: Rocket,
  plan: ClipboardList,
  issue: Ticket,
};

export function ArtifactList({ artifacts }: { artifacts: Artifact[] }) {
  return (
    <ul className="divide-y">
      {artifacts.map((a) => {
        const Icon = ICONS[a.type] ?? File;
        return (
          <li key={a.id} className="flex items-center gap-3 py-2.5 first:pt-0 last:pb-0">
            <span className="flex size-8 shrink-0 items-center justify-center rounded-md border bg-muted/50">
              <Icon className="size-4 text-muted-foreground" />
            </span>
            <div className="min-w-0 flex-1">
              {a.url ? (
                <a
                  href={a.url}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-1 truncate text-sm font-medium hover:underline"
                >
                  <span className="truncate">{a.label}</span>
                  <ExternalLink className="size-3 shrink-0 text-muted-foreground" />
                </a>
              ) : (
                <p className="truncate text-sm font-medium">{a.label}</p>
              )}
              <p className="text-xs text-muted-foreground capitalize">{a.type.replace("_", " ")}</p>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
